import React, { useState, useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";
import { planSelected as planSelectedAction } from "@/redux/actions/plans";

import { CustomRadioListBottomSheet } from "@/components/molecules/CustomRadioListBottomSheet/index";
import {
  RideSelect,
  RideSkeleton,
} from "@rimac-seguros/ride-system-components";

import { ModalRadioList } from "@/components/molecules/ModalRadioList/index";
import { usePlansContext } from "../../../context/PlansContext";

import "./styles.scss";

export const CreditBankSelector = ({
  list,
  defaultValue,
  register,
  setValue,
  watch,
  errors,
  clearErrors,
  isSmallScreen,
}) => {
  const dispatch = useDispatch();
  const planSelected = useSelector((state) => state.plans.planSelected);
  const { idCotizacion } = planSelected || {};

  const [openCreditBank, setOpenCreditBank] = useState(false);
  const [openCreditBankDesktop, setOpenCreditBankDesktop] = useState(false);
  const { loadingBanks } = usePlansContext();

  const creditBankValue = watch("creditBank");

  const mappingList = list?.map((item) => ({
    id: item.idEntidadFinanciera,
    value: item.idEntidadFinanciera,
    label: item.nombre,
    abreviatura: item.abreviatura,
    idTercero: item?.idTercero,
    razonSocial: item?.razonSocial
  }));

  const handleClick = (e) => {
    if (mappingList?.length <= 0) return;
    if (isSmallScreen) {
      setOpenCreditBank(e);
    } else {
      setOpenCreditBankDesktop(e);
    }
  };

  useEffect(() => {
    if (defaultValue && Object.keys(defaultValue).length > 0) {
      setValue("creditBank", String(defaultValue.idEntidadFinanciera));
    }
  }, [defaultValue]);

  useEffect(() => {
    if (creditBankValue) {
      const selectedOption = mappingList.find(
        (item) => String(item.value) === String(creditBankValue)
      );
      if (selectedOption && idCotizacion) {
        dispatch(
          planSelectedAction({
            ...planSelected,
            assuredFinancialEntity: {
              numId: selectedOption?.value,
              name: selectedOption?.label,
              idTercero: selectedOption?.idTercero,
              razonSocial: selectedOption?.razonSocial,
            },
          })
        );
        if (errors?.creditBank) {
          clearErrors("creditBank");
        }
      }
    }
  }, [creditBankValue, idCotizacion]);

  return (
    <>
      <div className="relative border-b border-ride-sys-color-border-default">
        <h2 className="flex items-center ride-sys-text-title-xlarge-default mb-ride-gl-spacing-2xlarge gap-ride-gl-spacing-large lg:ride-sys-text-title-2xlarge-default lg:mb-ride-gl-spacing-4xlarge">
          ¿Con qué banco tienes tu crédito?
        </h2>
        <div className="flex overflow-x-auto gap-ride-gl-spacing-large pb-ride-gl-spacing-4xlarge px-ride-gl-spacing-4xlarge -mx-ride-gl-spacing-4xlarge md-special:-mx-ride-gl-spacing-7xlarge md-special:px-ride-gl-spacing-7xlarge md:mx-0 md:px-0 lg:flex-wrap lg:gap-ride-gl-spacing-xlarge">
          {mappingList && mappingList.length > 0 ? (
            <>
              <RideSelect
                {...register("creditBank", { required: true })}
                options={mappingList}
                value={creditBankValue}
                disabled={loadingBanks}
                error={!!errors?.creditBank}
                errorMessage="Elige un banco"
                onOpenChange={(open) => handleClick(open)}
              />
              <div
                className="credit-bank_mask"
                onClick={() => handleClick(true)}
              />
            </>
          ) : (
            <RideSkeleton type="rectangle" height={48} width="100%" />
          )}
        </div>
        <CustomRadioListBottomSheet
          title={"Confirma tu banco"}
          list={mappingList}
          isOpen={openCreditBank}
          setIsOpen={setOpenCreditBank}
          name="creditBank"
          setValue={setValue}
          value={creditBankValue}
        />
        <ModalRadioList
          list={mappingList}
          isOpen={openCreditBankDesktop}
          setIsOpen={setOpenCreditBankDesktop}
          name="creditBank"
          setValue={setValue}
          value={creditBankValue}
        />
      </div>
    </>
  );
};
